import { ChevronDown } from 'lucide-react'
import { type ReactNode, forwardRef } from 'react'

import { cn } from '@/lib/ui/style-helpers'

import { Button, type ButtonProps } from '@/components/lemmala-design-system/button/button'
import { filterTriggerVariants } from '@/components/lemmala-design-system/table/variants'

type AgFilterTriggerProps = Omit<ButtonProps, 'value'> & {
  label: ReactNode
  value?: ReactNode
  attached?: boolean
  standalone?: boolean
  showChevron?: boolean
}

export const AgFilterTrigger = forwardRef<HTMLButtonElement, AgFilterTriggerProps>(
  (
    {
      label,
      value,
      attached = false,
      standalone = false,
      showChevron = false,
      className,
      ...props
    },
    ref,
  ) => {
    const isSelected = value !== undefined && value !== null && value !== ''
    return (
      <Button
        ref={ref}
        size='default'
        variant='ghost'
        className={cn(
          filterTriggerVariants({
            state: isSelected ? 'selected' : 'unselected',
            attached,
            standalone,
          }),
          className,
        )}
        {...props}
      >
        <span className='leading-5'>
          {isSelected ? (
            <>
              <span className='text-body-default'>{label}: </span>
              <span className='text-label-default'>{value}</span>
            </>
          ) : (
            label
          )}
        </span>
        {showChevron && (
          <ChevronDown
            className={cn(
              'size-4',
              isSelected ? 'text-main-foreground-accent' : 'text-main-foreground-tertiary',
            )}
          />
        )}
      </Button>
    )
  },
)
AgFilterTrigger.displayName = 'AgFilterTrigger'
